export const CarouselData = [
    {
        image:"https://www.sefalana.com/data/f1633971176.jpg"
    },
     {
        image:"https://www.sefalana.com/data/f1633975096.jpg"
    },
     {
        image:"https://www.sefalana.com/data/f1633975079.jpg"
    },
     {
        image:"https://www.sefalana.com/data/f1633975142.jpg"
    },
    {
        image:"https://www.sefalana.com/data/f1633975051.jpg"
    },
];